import React, { useEffect, useState } from 'react'
import useAuth from '../hooks/auth'
import helperService from '../services/helperService'
import AuthService from '../services/authService'
import Loader from '../components/Loader'
import {useRouter} from 'next/router'
import Logout from '../pages/logout'
import hs from '../services/helperService'

/**
 * Note that expiration is derived from teams.subscriptions.updatedDate + teams.subscriptions.duration which is BONKERS - needs to be redone from scratch
 */

function AuthStateChanged({ children, setter, alert }) {
	const { setUser, user } = useAuth()
	const [scenario, setScenario] = useState('loading')
	const Router = useRouter()
	useEffect(() => {
		AuthService.waitForUser(async userCred => {
			if (userCred && !userCred.loaded) {
				try {
					const {user, data} = await helperService.awaitFetch('/api/runner', { action: 'bootstrap', email: userCred?.email })

					let currentDate, expirationDate, plan, subscriptionId, planName, subscription
					if (user?.team && user?.role === 'webUser') {

						if (data.team.subscriptions && data.team.subscriptions.length > 0)
							subscription = data.team.subscriptions[0]
						else {
							subscription = await helperService.awaitFetch('/api/runner', {
								action: 'fetchOne',
								type: 'UserSubscription',
								query: {team: user.team ? user.team : ''}
							})
						}

						if (subscription){
							user.trialPeriodEnd = subscription.trialPeriodEnd || null

							// if (data?.team?.subscriptions?.[0]?.trialPeriodEnd && new Date(data?.team?.subscriptions?.[0]?.trialPeriodEnd) < new Date()) {
							// 	subscription.duration = 0
							// }
							currentDate = new Date()
							expirationDate = new Date(subscription.updated || subscription.updatedDate)
							expirationDate.setMonth(expirationDate.getMonth() + subscription.duration)
							subscriptionId = (data?.team?.subscriptions?.length > 0 && data?.team?.subscriptions?.[0]?.stripeSubscription) ?
								subscription.stripeSubscription?.id : subscription?.subscriptionId || null
							plan = subscription.packageParameters || {}
							planName = subscription.planName
						}

						if (subscription && currentDate?.getTime() >= expirationDate?.getTime() && subscription.autoRenew
						&& helperService.isValidPlanToRenew(subscription.planName)){
							const response = await helperService.awaitFetch('/api/fetchSubscription', {
									subscriptionId
								}),
								latestInvoice = response?.latestInvoice,
								stripeSubscription = response?.subscription

							if (stripeSubscription) {
								const periodStart = new Date(stripeSubscription.current_period_start * 1000),
									periodEnd = new Date(stripeSubscription.current_period_end * 1000),
									durationInMonths =
										  (periodEnd.getFullYear() - periodStart.getFullYear()) * 12 +
										  (periodEnd.getMonth() - periodStart.getMonth())
										  if (latestInvoice.paid && new Date (stripeSubscription.current_period_end * 1000) >= new Date(expirationDate)) {
									expirationDate = new Date(stripeSubscription.current_period_end * 1000)
									helperService.log('SIGNUP', 'Auto Renewal process: User subscription has been renewed',
										user?._id, user?.email, user?.team)
									if (data?.team?.subscriptions?.length > 0) {
										await helperService.awaitFetch('/api/runner', {
											action: 'update',
											type: 'Team',
											_id: data?.team?._id,
											data: {
												$set: {
													'subscriptions.0.updatedDate': new Date(stripeSubscription.current_period_start * 1000),
													'subscriptions.0.duration': durationInMonths,
													'subscriptions.0.trialPeriodEnd': null,
													'subscriptions.0.stripeSubscription' : response.subscription
												}
											}
										})
									} else {
										await helperService.awaitFetch('/api/runner', {
											action: 'updateWithoutTimeStamp',
											type: 'UserSubscription',
											_id: subscription?._id,
											data: { updated: new Date(stripeSubscription.current_period_start * 1000) }
										})
										const teams = await helperService.get({_id : data.team._id}, 'Team')
										data.team.subscriptions[0] = subscription
										data.team.subscriptions[0].updatedDate =  new Date(stripeSubscription.current_period_start * 1000)
										data.team.subscriptions[0].duration = durationInMonths
										data.team.subscriptions[0].trialPeriodEnd = null
										data.team.subscriptions[0].stripeSubscription = response.subscription
										user.local.isPaymentDone = true
										await helperService.manage(user, 'User')
										await helperService.manage(data.team, 'Team')
									}
								}
							}
						}
					}
				  if (!user) userCred.userType = 'New'
					else if (user) {
						const userObject = userCred.toJSON()

						userObject.avatar = user.avatar || userCred.photoURL
						if (user.role.indexOf('master') > -1)
							userObject.userType = 'admin'
						else userObject.userType = 'user'
						userObject.role = user.role
						userObject.firstName = user.firstName
						userObject.lastName = user.lastName
						userObject.permissions = user.permissions
						userObject.history = user.history
						userObject.tools = user.tools
						userObject._id = user._id
						userObject.preferences = user.preferences
					    userObject.local = user.local
						userObject.organization = user.organization
						userObject.team = data.team
						userObject.role = user.role
						userObject.isStarted = user?.isStarted || false


					  // add to zoho
					  if (user.preferences?.tokens?.length > 0) {
						  user.local.connectedChannels = new Date()
						  hs.manage(user, 'User')
						  hs.awaitFetch('/api/runner', {
							  action: 'zoho',
							  task: 'addUsers',
							  users: [{
								  'Email': user.email,
								  'Connected_Channels': new Date()
							  }]
						  })
					  }


						if (user.team && user.role === 'webUser') {
							const pathname = Router.pathname

							if (userObject.preferences) {
								const  setupCompleted = userObject.preferences?.accounts?.filter(account => account.type === 'owned').length > 0,
									hasCompetitorsAccount = userObject.preferences?.accounts?.filter(account => account.type === 'competitor').length > 0,
									setupHasIndustry = userObject.preferences?.subspace,
									handle = userObject.preferences?.accounts?.filter(account => account.type === 'owned')[0]
								let hasInsufficientData = false
								if (handle) hasInsufficientData = handle.report?.archetypes?.length < 1 || handle.report?.intents?.length < 1 ||
								handle.report?.tags?.length < 5 || handle.report?.imagesCount < 15

								if (pathname === '/report' || pathname === '/planner' || pathname === '/dashboard') {
									if (setupCompleted) {
										if (hasInsufficientData) {
											Router.push('/planner')
											// alert(`Oops! You've insufficient data. Unable to redirect to ${pathname.substring(1)}`, 'warning')
										}
										else Router.push(pathname)
									} else if (alert) {
										Router.push('/planner')
										// alert('Please Complete Setup', 'warning')
									}
								} else if (pathname.includes('competitors')) {
									if (!hasCompetitorsAccount) {
										alert('Please add competitor at Setup', 'warning')
										Router.push('/planner')
									} else {
										Router.push('/competitors')
									}
								}
							}

							userObject.plan = plan
							//isValidPlanToRenew method return if its a paid plan
							userObject.isValidPlan =  helperService.isValidPlanToRenew(planName) ? (currentDate?.getTime() < expirationDate?.getTime()) : true
							userObject.isWebUserAdmin = user.isWebUserAdmin
							userObject.trialPeriodEnd = user.trialPeriodEnd
							userObject.planActiveUntil = expirationDate
							userObject.subscriptionId = subscriptionId
							userObject.planName = planName
							userObject.subscriptionType = user.subscriptionType

							// This condition added for plan is not valid then it will update user for field called local.isPaymentDone
							if (!userObject.isValidPlan) {
								const users = await helperService.get({_id : userObject._id}, 'User')
								// users[0].local.isPaymentDone = false
								await helperService.manage(users[0], 'User')
							}
						}
						setter(userObject, data)
					}
					userCred.loaded = true
					setUser(userCred)
					// if (userCred?.userType === 'New' && !Router.route('/signup')) setScenario('new user')
					setScenario(null)
				} catch (error){
					helperService.log(
						helperService.vars.logTypes.LOGIN,
						`Login Failed : ${JSON.stringify(error)}`,
						userCred.email,
						userCred.email,
						undefined,
						undefined
					)
					setScenario(null)
				}
			}
			else {
				setScenario(null)
			}
		})
	}, [])

	if (scenario === 'loading') {
		return <Loader />
	}

	if (Router.route === '/logout') {
		return <Logout />
	}

	if (scenario === 'new user' && Router.route !== '/logout' && user !== null) {
		return (
			<div className="page">
				<h1>New User</h1>
				<p>
                    Sorry!
                    We can't find a user with this email address <i className="pinkText">{user?.email}</i> in our database.
                    Please reach out to your Success Consultant to get connected to this site.
				</p>
				<br />
				<button className="button marginAbove pinkGradientButton" onClick={ () => Router.push('/logout')}>Log Out</button>
			</div>
		)
	}
	return children
}
export default AuthStateChanged
